var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"umask"},[_c('van-overlay',{attrs:{"show":_vm.show},on:{"click":_vm.closeshow}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }